import React, { useRef } from 'react';
import { Calendar, MapPin, ChevronLeft, ChevronRight } from 'lucide-react';
import { portfolioData } from '../data/portfolio';

const SpeakingEngagements = () => {
  const { speakingEngagements } = portfolioData;
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 400;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="speaking" className="py-20 md:py-32 px-6 bg-[#0f0f0f]">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 flex items-center justify-between">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Speaking Engagements</h2>
            <div className="w-20 h-1 bg-[#00b4d8]"></div>
          </div>

          <div className="hidden md:flex gap-3">
            <button
              onClick={() => scroll('left')}
              className="bg-[#151515] border border-white/10 p-3 rounded-lg hover:border-[#00b4d8] hover:text-[#00b4d8] transition-all"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() => scroll('right')}
              className="bg-[#151515] border border-white/10 p-3 rounded-lg hover:border-[#00b4d8] hover:text-[#00b4d8] transition-all"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="relative">
          <div
            ref={scrollContainerRef}
            className="flex gap-6 overflow-x-auto pb-4 scroll-smooth hide-scrollbar"
            style={{
              scrollbarWidth: 'none',
              msOverflowStyle: 'none'
            }}
          >
            {speakingEngagements.map((engagement, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-[350px] bg-[#151515] border border-white/10 rounded-lg overflow-hidden hover:border-[#00b4d8] transition-all duration-300 group"
              >
                <div className="aspect-video bg-[#1a1a1a] overflow-hidden">
                  <img
                    src={engagement.imageUrl}
                    alt={engagement.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <div className="p-5">
                  <span className="inline-block text-xs font-semibold text-[#00b4d8] uppercase tracking-wider mb-3">
                    {engagement.event}
                  </span>

                  <h3 className="text-lg font-semibold mb-4 leading-tight group-hover:text-[#00b4d8] transition-colors">
                    {engagement.title}
                  </h3>

                  <div className="space-y-2 text-sm text-[#a0a0a0]">
                    <div className="flex items-center gap-2">
                      <Calendar size={14} className="text-[#00b4d8]" />
                      <span>{new Date(engagement.date).toLocaleDateString('en-US', { 
                        month: 'long', 
                        day: 'numeric', 
                        year: 'numeric' 
                      })}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin size={14} className="text-[#00b4d8]" />
                      <span>{engagement.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="absolute top-0 left-0 bottom-0 w-12 bg-gradient-to-r from-[#0f0f0f] to-transparent pointer-events-none"></div>
          <div className="absolute top-0 right-0 bottom-0 w-12 bg-gradient-to-l from-[#0f0f0f] to-transparent pointer-events-none"></div>
        </div>
      </div>

      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default SpeakingEngagements;
